import * as React from 'react'
import { cancelable } from '@owl-nest/cancelable-promise'
import * as Enum from '@owl-nest/legacy-enum'

export const AwaitStatus = Enum.create({
  LOADING: 0,
  SUCCESS: 1,
  FAILURE: 2,
})
export type AwaitStatus = Enum.ValueOf<typeof AwaitStatus>

type State<SUCCESS> =
  | {
      status: typeof AwaitStatus.LOADING
    }
  | {
      status: typeof AwaitStatus.SUCCESS
      success: SUCCESS
    }
  | {
      status: typeof AwaitStatus.FAILURE
      failure: any
    }

export function useAwait<SUCCESS>(promiseToAwait: Promise<SUCCESS>): State<SUCCESS> {
  const [state, setState] = React.useState<State<SUCCESS>>({
    status: AwaitStatus.LOADING,
  })

  React.useEffect(() => {
    const { cancel, promise } = cancelable(promiseToAwait)
    promise.then(
      (success) => {
        setState({ status: AwaitStatus.SUCCESS, success })
      },
      (failure) => {
        !failure.isCanceled && setState({ status: AwaitStatus.FAILURE, failure })
      },
    )
    return cancel
  }, [promiseToAwait])

  return state
}
